import OperationScreen from '../../features/operation/layouts/operation';

// TSS vite/01 §"Pages are thin" — lee la URL, monta una feature.
//
//   /admin/operation   la sección, con la ventana de tickets
//
// Los filtros de la ventana viven en la query (`?project=`, `?state=`,
// `?kind=`, `?page=`) y no en la ruta: son estado de la pantalla, se enlazan, y
// el botón Atrás los devuelve. La pestaña no está en el segmento porque todavía
// no hay pestañas — cuando existan los incidentes, esta página aprende un
// `:tab` como hizo la de Desarrollo.

export default function OperationPage() {
    return <OperationScreen />;
}
